
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Camera, CameraGroup, FaceClusterEvent } from '@/api';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { loadDataModule } from '@/store/data/LoadDataModule';
import NButton from '@/uikit/buttons/NButton.vue';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import WatchListGroup from '@/components/common/WatchListsGroup.vue';
import { dataModule } from '@/store/data';

@Options({
  name: 'ClusterItem',
  components: { NButton, NThumbnail, WatchListGroup },
  emits: ['show-cluster-event-image']
})
export default class InteractionItem extends Vue {
  @Prop({ type: Array, required: true })
  items!: number[];

  @Prop({ type: Boolean, default: false })
  readonly videoEnabled!: boolean;

  firstClusterItem?: FaceClusterEvent | null = null;
  secondClusterItem?: FaceClusterEvent | null = null;
  camera?: Camera | null = null;
  cameraGroup?: CameraGroup | null = null;

  async mounted() {
    await Promise.all([this.setFirstClusterItem(this.items[0]), this.setSecondClusterItem(this.items[1])]);
    await this.getCamera();
    await this.getCameraGroup();
  }

  get fullCameraName(): string {
    const cameraName = this.camera?.name ?? '?';
    const cameraGroupName = this.cameraGroup?.name ?? '?';
    return cameraName + ' / ' + cameraGroupName;
  }

  get canPlayVideo() {
    return this.videoEnabled && this.camera;
  }

  @Watch('firstClusterItem')
  async getCamera() {
    this.camera = null;
    if (this.firstClusterItem?.camera) {
      this.camera = await dataModule.camerasModule.getById(this.firstClusterItem?.camera);
    }
  }

  @Watch('firstClusterItem')
  async getCameraGroup() {
    const cameraGroup = this.firstClusterItem?.camera_groups?.[0];
    this.cameraGroup = null;
    if (cameraGroup) {
      this.cameraGroup = await dataModule.camerasModule.getById(cameraGroup);
    }
  }

  @Watch('items[0]')
  async setFirstClusterItem(id?: number): Promise<void> {
    this.firstClusterItem = id ? await loadDataModule.getClusterEventsByID({ id, type: 'faces' }) : undefined;
  }

  @Watch('items[1]')
  async setSecondClusterItem(id?: number): Promise<void> {
    this.secondClusterItem = id ? await loadDataModule.getClusterEventsByID({ id, type: 'faces' }) : undefined;
  }

  showClusterEventImage(items: FaceClusterEvent[]) {
    this.$photoViewer.show(items);
  }

  playVideo() {
    const firstDate = new Date(this.firstClusterItem!.created_date);
    const secondDate = new Date(this.secondClusterItem!.created_date);
    const resultTime = Math.min(firstDate.getTime(), secondDate.getTime()) / 1000;
    this.$videoPlayer.playArchive(this.camera!.id, resultTime - 3);
  }
}
